export const isNotNullish = <T>(v: T): v is NonNullable<T> => v != null;
